import Tracking from './sls-tracking';

const install = (Vue) => {
  Vue.directive('Track', Tracking);
};

/* eslint-disable no-undef */
if (window.Vue) {
  window.tracking = Tracking;
  Vue.use(install);
}

Tracking.install = install;
export default Tracking;
